<template>
	<TemplateSlideshow v-bind="props">
		<slot />
	</TemplateSlideshow>
</template>

<script lang="ts" setup>
import type { ImageType } from '#base/core/types/ImageType';
import type { SlideType } from '#base/core/types/SlideType';
import type { VideoType } from '#base/core/types/VideoType';

const props = defineProps<{
	slides: SlideType[];
	backgroundImage?: ImageType;
	backgroundVideo?: VideoType;
	isSales?: boolean;
}>();
</script>
